import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../../../components";
import {
  startRecordingThunk,
  clearRecording,
} from "../../../../redux/features/screenRecordingSlice";

const ScreenRecLeft = () => {
  const dispatch = useDispatch();
  const { recordingStatus, error } = useSelector(
    (state) => state.screenRecording
  );

  const handleStartRecording = async () => {
    try {
      // Clear any existing error before starting new recording
      dispatch(clearRecording());
      await dispatch(startRecordingThunk());
      // ... handle successful recording start
    } catch (err) {
      // TODO: handle recording start error
      console.log(err);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <motion.div
        className="z-10"
        transition={{ ease: "linear", duration: 0.5 }}
        initial={{ scale: 2 }}
        animate={{ scale: 1 }}
      >
        <img
          src="/img/recordingIcon.png"
          alt="screenRecordingIcon"
          width="180px"
        />
      </motion.div>
      <motion.div
        transition={{ ease: "linear", duration: 0.5 }}
        initial={{ scale: 0, y: 0 }}
        animate={{ scale: 1, y: "-10px" }}
      >
        <div className="flex flex-col items-center gap-4">
          {error && <p className="text-red-500 text-sm font-medium">{error}</p>}
          <Button
            version="black"
            text="Start Recording"
            width="fit-content"
            handleClick={handleStartRecording}
            disabled={recordingStatus === "recording"}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default ScreenRecLeft;
